import { ImageEdit, QuillEditor } from "@pathwright/blocks/src/shared"
import { MediaIconButton } from "@pathwright/legacy-media-manager"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import styled from "styled-components"
import { isMobile } from "../../utils"
import { QuoteAttributionWrapper, StyledQuoteContainer } from "./ui"
import { isEmptyAttribution } from "./utils"
import { QuoteContainer } from "./view"

const EditorWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > div {
    ${(p) =>
      p.blockStyles
        ? `
      color: ${p.blockStyles.styleAttributes.color};
    `
        : ""}
  }
`

const ImageWrapper = styled(ImageEdit)`
  .Blocks__ImageControls {
    height: 100%;
  }
`

const QuoteTextEditor = (props) => {
  const { data, onChange, blockStyles } = props

  return (
    <StyledQuoteContainer>
      <div style={{ margin: "10px 0" }}>
        <QuillEditor
          html={data.quote}
          placeholder={"Quote"}
          toolbar={TOOLBAR_CONFIG_TYPES.BASIC}
          onChange={(quote) => onChange({ quote })}
        />
      </div>
      <Content.Text>
        <EditorWrapper blockStyles={blockStyles}>
          <div
            style={{
              minWidth: isEmptyAttribution(data.attribution) ? 90 : 50,
              display: "flex",
              justifyContent: "center"
            }}
          >
            <QuoteAttributionWrapper
              isEmpty={isEmptyAttribution(data.attribution)}
            >
              <QuillEditor
                style={{ textAlign: "left", marginLeft: "0.1rem" }}
                html={data.attribution}
                placeholder={"Author"}
                onChange={(attribution) => onChange({ attribution })}
                createCustomToolbar={() => ["bold", "italic", "underline"]}
                controlled
              />
            </QuoteAttributionWrapper>
          </div>
        </EditorWrapper>
      </Content.Text>
    </StyledQuoteContainer>
  )
}

const QuoteEditor = (props) => {
  return (
    <QuoteContainer
      {...props}
      renderImage={(props) =>
        props.layout === "quoteImage" ? (
          <ImageWrapper
            isMobile={isMobile()}
            image={props.data.image}
            altText={props.data.altText}
            onChangeImage={(image) => props.onChange({ image })}
            imageStyle={{ borderRadius: "100%", width: 80, height: 80 }}
            imagePickerOptions={{
              transformations: {
                crop: { aspectRatio: 1, force: true },
                circle: true
              }
            }}
            renderButton={({ onClick }) => (
              <MediaIconButton
                isMobile={isMobile()}
                onClick={onClick}
                icon="shuffle"
              />
            )}
          />
        ) : null
      }
      renderQuote={(props) => <QuoteTextEditor {...props} />}
    />
  )
}

export default QuoteEditor
